<template>
  <header class="bg-white border-b border-slate-100 sticky top-0 z-50 shadow-sm">
    <div class="max-w-[1200px] mx-auto px-4 h-[70px] flex justify-between items-center">

      <!-- Logo -->
      <div class="flex-shrink-0">
        <router-link to="/">
          <img :src="require('../assets/logo.png')" alt="Logo" class="h-10 md:h-12 w-auto transition-transform hover:scale-105" />
        </router-link>
      </div>

      <!-- Desktop Navigation -->
      <nav class="hidden md:flex items-center space-x-8">
        <router-link
            :to="{'name':'calculator'}"
            class="text-sm font-bold uppercase tracking-wider text-slate-500 hover:text-slate-900 transition-colors"
            active-class="text-slate-900"
        >
          {{ $t('header.calculator') }}
        </router-link>

        <!-- Language Switcher -->
        <div class="flex items-center bg-slate-100 rounded-lg p-0.5">
          <button
              v-for="lang in languages"
              :key="lang"
              @click="changeLocale(lang)"
              :class="[locale === lang ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-400 hover:text-slate-700']"
              class="px-2.5 py-1 text-xs font-bold uppercase rounded-md transition-all"
          >
            {{ lang }}
          </button>
        </div>

        <button
            v-if="isAuth"
            @click="logout"
            class="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-red-500 hover:bg-red-50 px-4 py-2 rounded-xl transition-all"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          <span>{{ $t('header.logout') }}</span>
        </button>
      </nav>

      <!-- Mobile Hamburger Button -->
      <div class="md:hidden flex items-center">
        <button @click="showMenu = !showMenu" class="text-slate-600 hover:text-slate-900 p-2 outline-none">
          <svg v-if="!showMenu" class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
          <svg v-else class="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Menu Dropdown -->
    <transition
        enter-active-class="transition duration-200 ease-out"
        enter-from-class="opacity-0 -translate-y-4"
        enter-to-class="opacity-100 translate-y-0"
        leave-active-class="transition duration-150 ease-in"
        leave-from-class="opacity-100 translate-y-0"
        leave-to-class="opacity-0 -translate-y-4"
    >
      <div v-if="showMenu" class="md:hidden bg-white border-b border-slate-100 absolute w-full left-0 shadow-xl">
        <div class="flex flex-col p-4 space-y-4">
          <router-link
              :to="{'name':'calculator'}"
              @click="showMenu = false"
              class="text-base font-bold text-slate-700 p-3 hover:bg-slate-50 rounded-lg"
          >
            {{ $t('header.calculator') }}
          </router-link>

          <!-- Language Switcher -->
          <div class="flex items-center gap-2 p-3">
            <button
                v-for="lang in languages"
                :key="lang"
                @click="changeLocale(lang)"
                :class="[locale === lang ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-500']"
                class="px-4 py-1.5 text-sm font-bold uppercase rounded-lg transition-all"
            >
              {{ lang }}
            </button>
          </div>

          <button
              v-if="isAuth"
              @click="logout"
              class="text-left text-base font-bold text-red-500 p-3 hover:bg-red-50 rounded-lg flex items-center gap-3"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            {{ $t('header.logoutFull') }}
          </button>
        </div>
      </div>
    </transition>
  </header>
</template>

<script>
import { useI18n } from "vue-i18n";
import eventBus from "@/eventBus";

export default {
  name: "header-index",
  setup() {
    const { locale } = useI18n({ useScope: "global" });
    const setLocale = (lang) => {
      locale.value = lang;
      localStorage.setItem('locale', lang);
    };
    return { locale, setLocale };
  },
  data() {
    return {
      isAuth: false,
      showMenu: false,
      languages: ['pl', 'en'],
    }
  },
  mounted() {
    this.checkAuth();
    eventBus.$on('login', this.checkAuth);
    // Закрываем меню при ресайзе в десктоп
    window.addEventListener('resize', () => {
      if (window.innerWidth > 899) this.showMenu = false;
    });
  },
  methods: {
    checkAuth() {
      this.isAuth = !!localStorage.getItem('token');
    },
    changeLocale(lang) {
      this.setLocale(lang);
      this.showMenu = false;
    },
    logout() {
      localStorage.removeItem('token');
      window.location.reload();
    }
  }
}
</script>

<style scoped>
.router-link-active {
  @apply text-slate-900 border-b-2 border-slate-900 md:border-none;
}
</style>